<div class="resource-card" (click)="navigateToResource()">
  <div class="resource-card__left">
    <img [src]="coverUrl" alt="Resource" />
  </div>
  <div class="resource-card__right">
    <div class="resource-card__right__header">
      <div class="resource-card__right__header__title">{{ resource?.title }}</div>
      <div class="resource-card__right__header__subtitle" *ngIf="resource?.icon">
        <span [className]="resource?.icon?.className">{{ resource?.icon?.icon }}</span>
        <span class="resource-type">{{ resource?.icon?.label | translate }}</span>
      </div>
    </div>
    <div class="resource-card__right__body">
      <div>
        <div class="resource-card__right__body__left" *ngIf="resource?.progress">
          <div class="resource-card__right__body__left__progress" *ngIf="resource?.progress < 85">
            <span class="pctg">{{ resource?.progress }}%</span>
            <mat-progress-bar mode="determinate" [opacTooltip]="(resource?.progress).toString() + '%' ?? ''" [value]="resource?.progress"></mat-progress-bar>
          </div>
          <div class="resource-card__right__body__left__status" *ngIf="resource?.progress >= 85">
            <span class="status-label">{{ completionLabel }}</span>
            <span
              class="career-plan-resource-status"
              [ngClass]="{
                'career-plan-resource-status--completed': resource?.progress >= 85,
                'career-plan-resource-status--checking': resource?.progress < 85
              }">
            </span>
          </div>
        </div>
      </div>

      <opac-button>
        <opac-icon slot="only-icon" icon="navigate_next"></opac-icon>
      </opac-button>
    </div>
  </div>
</div>
